const OrderEmisionList = () =>
  import("@/views/orderEmision/OrderEmisionList");

const OrderEmision = () =>
  import("@/views/orderEmision/OrderEmision");

const OrderEmisionVehicleNewRisk = () =>
  import("@/views/orderEmision/OrderEmisionVehicleNewRisk");

const OrderEmisionVehicleRenovation = () =>
  import("@/views/orderEmision/OrderEmisionVehicleRenovation");

const OrderEmisionGeneralBoardNewRisk = () =>
  import("@/views/orderEmision/OrderEmisionGeneralBoardNewRisk");

const OrderEmisionGeneralBoardRenovation = () =>
  import("@/views/orderEmision/OrderEmisionGeneralBoardRenovation");

const OrderEmisionOtherMovements = () =>
  import("@/views/orderEmision/OrderEmisionOtherMovements");

export const OrderEmisionListRoute = {
  path: "orderEmisionList",
  component: OrderEmisionList,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",   
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Consulta",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};


export const OrderEmisionVehicleNewRiskRoute = {
  path: "vehicleNewRisk",
  component: OrderEmisionVehicleNewRisk,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/orderEmision/orderEmisionList",
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Vehículos(riesgo nuevo)",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};

export const OrderEmisionVehicleRenovationRoute = {
  path: "vehicleRenovation",
  component: OrderEmisionVehicleRenovation,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/orderEmision/orderEmisionList",
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Vehículos(renovación)",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};

export const OrderEmisionGeneralBoardNewRiskRoute = {
  path: "generalBoardNewRisk",
  component: OrderEmisionGeneralBoardNewRisk,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/orderEmision/orderEmisionList",
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Ramos generales(Nuevo riesgo)",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};

export const OrderEmisionGeneralBoardRenovationRoute = {
  path: "generalBoardRenovation",
  component: OrderEmisionGeneralBoardRenovation,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/orderEmision/orderEmisionList",
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Ramos generales(Renovación)",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};

export const OrderEmisionOtherMovementsRoute = {
  path: "otherMovements",
  component: OrderEmisionOtherMovements,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/orderEmision/orderEmisionList",
    breadcrumb: [
      {
        text: "Orden de emisión",
        disabled: true,
        href: "#"
      },
      {
        text: "Otros movimientos",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive","aps_promotor"],
  }
};

export const OrderEmisionRoute = {
  path: "orderEmision",
  component: OrderEmision,
  redirect: '/orderEmision/orderEmisionList',
  children: [
    OrderEmisionListRoute,
    OrderEmisionVehicleNewRiskRoute,
    OrderEmisionVehicleRenovationRoute,
    OrderEmisionGeneralBoardNewRiskRoute,
    OrderEmisionGeneralBoardRenovationRoute,
    OrderEmisionOtherMovementsRoute,
  ]
}